import React, { useContext } from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import {
  FacebookShareButton,
  LineShareButton,
  WeiboShareButton,
  WeiboIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";

import { ReactComponent as FacebookSvg } from "../../assets/icons/facebook.svg";
import { ReactComponent as LineSvg } from "../../assets/icons/line.svg";
import { ReactComponent as CopyLinkSvg } from "../../assets/icons/copy-link.svg";
import { toast } from "react-toastify";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";
import ProfileContext from "./ProfileContext";

const Share = ({ onClose }) => {
  const { getLang } = useContext(AppContext);
  const { user, company, isCompany } = useContext(ProfileContext);
  const Translation = getLang(langComponent.profile);

  const profileLink = `https://urbaan.app/${
    isCompany ? `companies/${company._id}` : user.uri
  }`;

  const handleCopyToClipboard = (type) => {
    navigator.clipboard.writeText(profileLink);

    toast.info("Copied profile link to clipboard", {
      autoClose: 2000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    });
  };

  return (
    <Overlay
      onClose={onClose}
      content={
        <div className="profile-share">
          <h3 className="profile-share__header">
            {Translation("Share profile")}
          </h3>
          <div className="profile-share-list">
            <div
              className="profile-share-list-item"
              onClick={handleCopyToClipboard}
            >
              <div className="profile-share-list-item__border">
                <CopyLinkSvg className="profile-share-list-item__icon profile-share-list-item__icon--small" />
              </div>
              {Translation("Copy Link")}
            </div>
            <FacebookShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <FacebookSvg className="profile-share-list-item__icon" />
                Facebook
              </div>
            </FacebookShareButton>
            <LineShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <LineSvg className="profile-share-list-item__icon" />
                Line
              </div>
            </LineShareButton>
            {/* <WeiboShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <WeiboIcon className="profile-share-list-item__icon" />
                Weibo
              </div>
            </WeiboShareButton>
            <FacebookMessengerShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <FacebookMessengerIcon className="profile-share-list-item__icon" />
                Messenger
              </div>
            </FacebookMessengerShareButton> */}
          </div>
        </div>
      }
    />
  );
};

Share.propTypes = {};

export default Share;
